import { Editor } from 'slate';

import serverInterface from 'server-interface';

import { parse } from 'utilities/routes';

import elementTypes from '../../../elements/types';

import HelptapEditor from '../../';

export function buildNode(synchronizedPageRegion) {

  const node = {
    type: elementTypes.SYNCHRONIZED_PAGE_REGION,
    children: [{ text: '' }],
    id: crypto.randomUUID(),
    synchronizedPageRegionId: synchronizedPageRegion._id
  };

  return node;

}

export function isInsideRegion(editor, path) {

  const [node] = Editor.node(editor, [path[0]]);

  return node.type === elementTypes.SYNCHRONIZED_PAGE_REGION;

}

export function isSynchronizedPageRegion(node) {

  return node.type === elementTypes.SYNCHRONIZED_PAGE_REGION;

}

export function insert(editor, node) {

  const synchronizedPageRegionId = node.synchronizedPageRegionId;

  const parameters = parse(window.location.href, '/pages/:pageId');

  if (parameters !== null) {
    const pageId = parameters.pageId;
    serverInterface.startup.synchronizedPageRegions.trackSynchronizedPageRegionReference(synchronizedPageRegionId, pageId);
  }

  node.id = crypto.randomUUID();

  HelptapEditor.insertNodes(editor, node);

}